import React from "react";
import { Button } from "@mui/material";
import { Client } from "../../../interfaces/ClientInterface";
import { Training } from "../../../interfaces/TrainingInterface";
import MultipleButtonGroup from "../../../components/MultipleButtonGroup";
import Template1 from "./Template1";
import useCurrentResourceCentre from "../../../hooks/useCurrentResourceCentre";

interface PropType {
  client: Client;
  training: Training;
}

export function CertificatePrinter({ client, training }: PropType): React.ReactNode {
  const resourceCentre = useCurrentResourceCentre();
  return (
    <MultipleButtonGroup
      options={[
        {
          label: "Print Template 1",
          onClickAction: () => ({}),
          component: (
            <Template1
              client={client}
              training={training}
              resourceCentre={resourceCentre}
              trigger={
                <Button size="small" variant="contained">
                  Print Template 1
                </Button>
              }
            />
          )
        }
      ]}
    />
  );
}

export default CertificatePrinter;
